export class State {

  static getInstance(): { [key: string]: any } {
    return history.state as { [key: string]: any };
  }

  static hasInstanceItem(key: string): boolean {
    return Object.prototype.hasOwnProperty.call(history.state, key);
  }

  static hasInstanceItems(keys: string[]): boolean {
    return keys
      .map((key: string) => Object.prototype.hasOwnProperty.call(history.state, key))
      .indexOf(false) < 0;
  }

  static getInstanceItem(key: string): any {
    if (!Object.prototype.hasOwnProperty.call(history.state, key)) {
      return null;
    }

    const { state } = history;

    return (state as { [key: string]: any })[key];
  }

  static setInstanceItem(key: string, item: any): any {
    try {
      (history.state as { [key: string]: any })[key] = item;
    } catch (e) {
      return null;
    }

    return item;
  }

  static removeInstanceItem(key: string): boolean {
    if (!Object.prototype.hasOwnProperty.call(history.state, key)) {
      return false;
    }

    delete (history.state as { [key: string]: any })[key];

    return true;
  }
}
